module.exports = __webpack_public_path__ + "static/media/490JamesPBrawleyDrNW_2018-06-12_171.6acb7628.jpg";